<script>
export default {
    name: "QuestionaireForm",

    props: {

        questionaires: Array,
        showModal: Boolean,
    },

    methods: {

        saveData(questionaire) {
            this.$root.loading = true;
            this.$http.post(`PatientRegistration/PatientQuestionnairesDetails`, questionaire).then(() => {
                this.$root.loading = false;
                this.$emit('refresh');
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/2 sm:w-11/12">
      <template v-slot:title>
        <h5 class="font-bold text-base">Questionaire</h5>
      </template>
      <template v-slot:modal-body>
          <div class="w-full overflow-auto">
              <table class="table table-hover">
                  <thead class="bg-blue-500 text-sm text-white whitespace-no-wrap">
                      <tr>
                          <th class="p-tiny">ID</th>
                          <th class="p-tiny">Question</th>
                          <th class="p-tiny">Tick If  Yes</th>
                          <th class="p-tiny">Comment</th>
                          <td class="p-tiny">Action</td>
                      </tr>
                  </thead>
                  <tbody class="text-xs">
                      <tr v-for="(questionaire, idx) in questionaires" :key="idx">
                          <td class="p-tiny">{{ questionaire.id }}</td>
                          <td class="p-tiny">{{ questionaire.question }}</td>
                          <td class="p-tiny">
                              <input type="checkbox" v-model="questionaire.status">
                          </td>
                          <td class="p-tiny">
                              <input type="text" class="input-sm input-control" v-model.trim="questionaire.comment">
                          </td>
                          <td class="p-tiny">
                              <button class="btn-sm btn-info" @click.prevent="saveData(questionaire)"><i class="fa fa-save"></i> Save</button>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs mr-4" @click="$emit('closeModal')"><i class="fa fa-times"></i> Cancel</button>
      </template>
    </tail-modal>
</template>